import React from 'react'
import { getIcon } from './utils/getIcon'
import { IconContainer } from './styles'
import type { IconProps } from './utils/types'

export const Icon = (props: IconProps) => {
    const { marginTop, marginRight, marginBottom, marginLeft } = props
    const icon = getIcon(props)

    return (
        <IconContainer
            marginTop={marginTop}
            marginRight={marginRight}
            marginBottom={marginBottom}
            marginLeft={marginLeft}>
            {icon}
        </IconContainer>
    )
}
